import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { applyCmsFeed } from './cms/store'
import type { TiggBoot } from './seo/boot'

declare global {
  interface Window {
    __TIGG_BOOT__?: TiggBoot
  }
}

if (typeof window !== 'undefined' && window.__TIGG_BOOT__?.feed) {
  applyCmsFeed(window.__TIGG_BOOT__.feed, { cardsIndexed: window.__TIGG_BOOT__.cardsIndexed })
}

const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

const root = document.getElementById('root')!
if (root.hasChildNodes()) hydrateRoot(root, app)
else createRoot(root).render(app)
